import React from "react";
import BrandSettingForm from "./BrandSettingForm";

const EditBrandSetting = ({ brandSettingData }) => {
  return <BrandSettingForm isEdit={true} brandSettingData={brandSettingData} />;
};

export default EditBrandSetting;